var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{attrs:{"id":"watermark"}}),_vm._m(0),_c('div',{attrs:{"id":"canvas"}}),_c('tophead-Bar'),_c('homecontainer-Bar',{on:{"transfer":_vm.transfer,"modelButton":_vm.modelButton}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"BottomInfo"}},[_c('span',{staticClass:"shine"},[_vm._v("Designed By Sumhoo Technology")])])
}]

export { render, staticRenderFns }